<template>
  <!-- ══════════════════════════════════════════════
       SECTION 1 — Bande features 6 icônes
  ══════════════════════════════════════════════ -->
  <section class="features-strip">
    <div class="features-strip__grid">
      <!-- Ligne haute : 3 features -->
      <div class="features-strip__row">
        <div
          v-for="feature in featuresTop"
          :key="feature.label"
          class="feature-item"
        >
          <div class="feature-item__icon">
            <img :src="feature.img" :alt="feature.label" />
          </div>
          <p class="feature-item__label">{{ feature.label }}</p>
        </div>
      </div>

      <!-- Séparateur pointillé horizontal -->
      <div class="features-strip__divider" aria-hidden="true"></div>

      <!-- Ligne basse : 3 features -->
      <div class="features-strip__row">
        <div
          v-for="feature in featuresBottom"
          :key="feature.label"
          class="feature-item"
        >
          <div class="feature-item__icon">
            <img :src="feature.img" :alt="feature.label" />
          </div>
          <p class="feature-item__label">{{ feature.label }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesStrip',

  data() {
    return {
      featuresTop: [
        {
          label: 'Paiements fournisseurs internationaux',
          img: require('@/assets/img/Overlay.png'),
        },
        {
          label: 'Encaissement clients étrangers en XOF',
          img: require('@/assets/img/moneoverlay.png'),
        },
        {
          label: 'Conversion XOF, devises optimisée PME',
          img: require('@/assets/img/Overlay (1).png'),
        },
      ],
      featuresBottom: [
        {
          label: 'Délais rapides (J0–J1)',
          img: require('@/assets/img/Overlay (2).png'),
        },
        {
          label: 'Support entreprise dédié',
          img: require('@/assets/img/Overlay (3).png'),
        },
        {
          label: 'Conformité réglementaire UEMOA',
          img: require('@/assets/img/Overlay (4).png'),
        },
      ],
    }
  },
}
</script>

<style scoped>
/* ════════════════════════════════════════════════
   TOKENS GLOBAUX
════════════════════════════════════════════════ */
.features-strip {
  --font:          'Sora', 'DM Sans', system-ui, sans-serif;
  --color-text:    #1a1a1a;
  --color-muted:   #6b6b6b;
  --color-border:  #e0ddd8;
  --color-bg-icon: #f2ede6;
  --radius-icon:   50%;
}

/* ════════════════════════════════════════════════
   SECTION 1 — FEATURES STRIP
════════════════════════════════════════════════ */
.features-strip {
  padding: 0 50px;
  margin-bottom: 72px;
}

.features-strip__grid {
  border: 1.5px solid var(--color-border);
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

/* Chaque row de 3 */
.features-strip__row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

/* Séparateurs verticaux entre colonnes */
.features-strip__row .feature-item {
  padding: 28px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  position: relative;
}

/* Trait pointillé vertical entre items */
.features-strip__row .feature-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 15%;
  height: 70%;
  border-right: 1.5px dashed var(--color-border);
}

/* Ligne pointillée horizontale entre les 2 rows */
.features-strip__divider {
  border-top: 1.5px dashed var(--color-border);
  margin: 0;
}

/* Icône ronde */
.feature-item__icon {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-icon);
  background-color: var(--color-bg-icon);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.feature-item__icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Label */
.feature-item__label {
  margin: 0;
  font-family: var(--font);
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--color-text);
  line-height: 1.4;
  max-width: 160px;
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Tablet (≤ 900px)
════════════════════════════════════════════════ */
@media (max-width: 900px) {
  .features-strip {
    padding-left: 24px;
    padding-right: 24px;
  }
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Mobile (≤ 600px)
════════════════════════════════════════════════ */
@media (max-width: 600px) {
  .features-strip {
    padding-left: 16px;
    padding-right: 16px;
  }

  /* Features : 2 colonnes au lieu de 3 */
  .features-strip__row {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Cacher le 3e item de la row du bas pour équilibrer si impair */
  .features-strip__row .feature-item:last-child:nth-child(odd) {
    grid-column: span 2;
  }
}
</style>
